import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { InvestmentPropertyScreen, TitleSection } from "../../components";

export default function InvestmentProperty() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Investment Property", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/investment-property-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <InvestmentPropertyScreen />
    </DefaultLayout>
  );
}
